import Fade from '@mui/material/Fade';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function SuccessMessage() {
  return (
    <Fade in={true}>
      <Stack spacing={4}>
        <Typography
          component="h1"
          variant="h5"
          align="center">
          Thank you!
        </Typography>
        <Typography
          component="h2"
          variant="h6"
          align="center">
          Active listening is the way we improve.<br />
          Your responses help us get better year after year.
        </Typography>
      </Stack>
    </Fade>
  );
}
